import { TranslateService } from '@ngx-translate/core';
import { FilesService } from 'src/app/services/shared/files/files.service';
import { getInvalidFields, prepareFieldConfigFlagsNew, getInvalidFieldsV2 } from 'src/app/functions/shared-functions';
import { ProfileSettingsService } from 'src/app/services/shared/profile-settings/profile-settings.service';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';
import { cloneArray, jsonParse } from 'src/app/app.component';
import { environment } from 'src/environments/environment';
/* Created by:Upendram Reddy Tanuja
Created on: 19-Sep-2019 11:30 AM
Purpose: To  display details*/
import { Component, ElementRef, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { JobService } from '../../services/job-details/job.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { SocialMediaShareComponent } from '../shared/social-media-share/social-media-share.component';
import { ResumeReferralDetailsComponent } from '../resume-referral/resume-referral-details/resume-referral-details.component';
import { ResumeReferralCopyComponent } from '../resume-referral-copy/resume-referral-copy.component';
import { Session } from 'src/app/classes/session/session';
import { SessionService } from 'src/app/services/session/session.service';
import { getSessionStorageItem, viewDocument } from 'src/app/controls/functions/functions';
import { ConfirmationComponent } from '../shared/confirmation/confirmation.component';
import { LoginComponentV2 } from '../login-v2/login.component';
import { MatDrawer } from '@angular/material/sidenav';
import { input_pdf_docs_only, jsonDeepParse, markFormGroupTouched } from 'src/app/controls/functions/shared-functions';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { StarRatingColor } from 'src/app/controls/components/rating/rating.component';
import { onlyAlphabets, email_pattern } from 'src/app/filters/filters.pipe';
import { getIP, JobseekerRegistrationService } from '../jobseeker-registration/services/registration/jobseeker-registration.service';
import { SuccessModalComponent } from '../shared/success-modal/success-modal.component';
import { RegistrationOtpComponent } from '../jobseeker-registration/components/registration-otp/registration-otp.component';
import { SkillRatingComponent } from 'src/app/controls/components/skill-rating/skill-rating.component';
import { AddResumeSkillsComponent } from '../jobseeker-registration/components/add-resume-skills/add-resume-skills.component';

@Component({
  selector: 'app-job-details',
  templateUrl: './job-details.component.html',
  styleUrls: ['./job-details.component.scss'],
  providers: [JobService, JobseekerRegistrationService, FilesService]
})
export class JobDetailsComponent implements OnInit {
  base_url = 'https://storage.googleapis.com/ezeone/icanrefer/'
  jobs: any = {};
  functions: any = [];
  education: any = [];
  skills: any = [];
  job_details_display;
  session = new Session();
  relevant_jobs = [];
  someDate = new Date();
  id: number;
  request = {
    resId: 0,
    sellerShortCode: '0',
    productCode: 0
  }
  @ViewChild('sideNav2', { static: false }) sidebar: MatDrawer;
  default_banner_url = 'assets/jobs/wehiring.svg';
  portal_details: any = {};
  socialMediaList: any = [];
  job_list = [];
  index = 0;
  field_config_access: any = {};
  portal_settings: any;

  isLinear = true;
  stepper_list = [{
    id: 1,
    title: "Personal Information",
    active: 1,
    disabled: 0,
  }, {
    id: 2,
    title: "Preferences, Skills and Education",
    active: 0,
    disabled: 1,

  }, {
    id: 3,
    title: "Employment and Rating",
    active: 0,
    disabled: 1,

  },
    // {
    //   id: 4,
    //   title: "Employment and Rating",
    //   active: 0,
    //   disabled: 0,
    // }
  ];
  steps = [0, 1, 0]
  masters: any = {}
  registration = {
    registration_mobile_length: 10,
    mobile_number_length: 10,
    alt_mobile_number_length: 10,
    key_skills: []
  };
  crDate = new Date();
  starCount: number = 5;
  commRatingLevels_masters = [];
  starColor: StarRatingColor = StarRatingColor.accent;
  current_preferred_location;
  stepperOrientation;
  checkFormValidation = 0;
  registrationForm = new UntypedFormGroup({
    cvPath: new UntypedFormControl(null),
    jobType: new UntypedFormControl(null),
    firstName: new UntypedFormControl(null, [Validators.pattern(onlyAlphabets)]),
    lastName: new UntypedFormControl(null, [Validators.pattern(onlyAlphabets)]),
    mobileNumber: new UntypedFormControl(null),
    mobileIsd: new UntypedFormControl(null),
    emailId: new UntypedFormControl(null, [Validators.pattern(email_pattern)]),
    address: new UntypedFormControl(null),
    profilePicture: new UntypedFormControl(null),
    isJobseeker: new UntypedFormControl(1),
    sellerShortCode: new UntypedFormControl(environment.SHORTCODE),
    cvFileName: new UntypedFormControl(null),
    resId: new UntypedFormControl(0),
    password: new UntypedFormControl(null, [Validators.minLength(6), Validators.pattern(/(?=.*\W)(?=.*\d)/)]),
    confirmPassword: new UntypedFormControl(null),
    ip: new UntypedFormControl(getIP().ip),
    latitude: new UntypedFormControl(null),
    longitude: new UntypedFormControl(null),
    referralCode: new UntypedFormControl(null),
    waMobileIsd: new UntypedFormControl(''),
    waMobileNumber: new UntypedFormControl(''),
    presentLocationId: new UntypedFormControl(null),
    otp: new UntypedFormControl(null)

  }, this.checkPassword);
  valid_captcha
  passValidation = {
    mandatory: 1,
    minLength: 6,
  }
  valid_captcha_flag = false;
  @ViewChild('recaptcha', { static: true }) captch_element: ElementRef;

  fileType = input_pdf_docs_only

  resumeBankForm = new UntypedFormGroup({
    firstName: new UntypedFormControl('', [Validators.pattern(onlyAlphabets)]),
    lastName: new UntypedFormControl('', [Validators.pattern(onlyAlphabets)]),
    mobileNumber: new UntypedFormControl(''),
    mobileIsd: new UntypedFormControl(''),
    altMobileIsd: new UntypedFormControl(),
    altMobileNumber: new UntypedFormControl(''),
    altEmailId: new UntypedFormControl(''),
    waMobileIsd: new UntypedFormControl(''),
    waMobileNumber: new UntypedFormControl(''),
    genderCode: new UntypedFormControl(1),
    emailId: new UntypedFormControl('', [Validators.pattern(email_pattern)]),
    dob: new UntypedFormControl(),
    resumeStatusCode: new UntypedFormControl(0),
    interestedAfterDate: new UntypedFormControl(new Date()),
    presentLocation: new UntypedFormControl(''),
    latitude: new UntypedFormControl(null),
    longitude: new UntypedFormControl(null),
    resId: new UntypedFormControl(0),
    restrictDirectSubmission: new UntypedFormControl(),
    countryCode: new UntypedFormControl(''),
    totalExp: new UntypedFormControl(0, [Validators.min(0), Validators.max(99)]),
    anyKeywords: new UntypedFormControl(''),
    presentEmployer: new UntypedFormControl(''),
    designation: new UntypedFormControl('', Validators.maxLength(100)),
    noticePeriod: new UntypedFormControl(30, [Validators.min(0), Validators.max(365), Validators.pattern('^(?:36[0-5]|3[0-5][0-9]|[12][0-9][0-9]|[1-9][0-9]|[0-9])$')]),
    presentSalaryCurrId: new UntypedFormControl(),
    presentSalary: new UntypedFormControl(0,),
    presentSalaryScaleDurationId: new UntypedFormControl(null),
    expSalaryCurrId: new UntypedFormControl(null),
    expSalary: new UntypedFormControl(0,),
    expSalaryScaleDurationId: new UntypedFormControl(1),
    declareResumeOwnership: new UntypedFormControl(), // before saving when resId = 0
    jobType: new UntypedFormControl(null),
    // jobType: new FormArray([], minSelectedCheckboxes(0)),
    cvKeywords: new UntypedFormControl(''),
    cvPath: new UntypedFormControl(''),
    cvFileName: new UntypedFormControl(''),
    profilePicture: new UntypedFormControl(''),
    isEditable: new UntypedFormControl(1),
    industry: new UntypedFormControl(),
    certification: new UntypedFormControl(),
    // rating: new FormControl(),
    partnerId: new UntypedFormControl(''),
    linkPartner: new UntypedFormControl(0),
    keySkills: new UntypedFormControl(null),
    roles: new UntypedFormControl(),
    isIntJS: new UntypedFormControl(),
    isHeight: new UntypedFormControl(0),
    nationalityCode: new UntypedFormControl(),
    workPermits: new UntypedFormControl(),
    languages: new UntypedFormControl(),
    heightCode: new UntypedFormControl(1),
    visionCode: new UntypedFormControl(1),
    bodyTypeCode: new UntypedFormControl(1),
    isVision: new UntypedFormControl(0),
    isBodyType: new UntypedFormControl(0),
    isPremiumRole: new UntypedFormControl(0),
    abilities: new UntypedFormControl(),
    isPhysicalChecked: new UntypedFormControl(1),
    productCode: new UntypedFormControl(null),
    fileName: new UntypedFormControl(null),
    consultants: new UntypedFormControl([]),
    cvSourceType: new UntypedFormControl(1),
    cvType: new UntypedFormControl(1),
    notes: new UntypedFormControl(null),
    isJobseeker: new UntypedFormControl(1),
    sellerShortCode: new UntypedFormControl(environment.SHORTCODE),
    preferredLocation: new UntypedFormControl([]),
    preferredLocationIds: new UntypedFormControl([]),
    commSkillRating: new UntypedFormControl(1),
    cvRating: new UntypedFormControl(1),
    education: new UntypedFormControl(null),
    jobTitleId: new UntypedFormControl(null),
    skillRankingList: new UntypedFormControl(null),
    referralCode: new UntypedFormControl(null),
    presentLocationId: new UntypedFormControl(null),
    extendedData: new UntypedFormControl(null),
    extendedDataUI: new UntypedFormControl(null),

  })
  session_obj: Session = new Session()

  jobseeker = {
    registration_prev_obj: null,
    is_misd_disabled: false,
    mobile_number_length: 15,
    alt_mobile_number_length: 15,
    registration_mobile_length: 15,
    partner_id: 0,
    partner_name: '',
    partnerFound: false,
    partnerNotFound: false,
    userDetails: null,
    show_partner_flag: false,
    user_session_info: null,
    is_new_partner: true,
    submitPanelFlag: false,
    cv_url: '',
    hide: true,
    valid_consultant: false,
    consultants: [],
    backup_consultant: null,
    pdf: null,
    image: null,
    url: null,
    loading: false,
    files: [],
    cvSourceList: [],
    cvTypeList: [],
    myFlagForButtonToggleMultiple: [],
    getting_data: false,
    default_form_group_data: null,
    job_type_list: [],
    file_data: null,
    current_status_obj: {
      resumeStatusCode: 0
    },
    current_tab_details: null,
    current_res_id: 0,
    default_cv_types: [],
    current_cv_types: [],
    current_education: {
      isPassing: 0,
      isSpecialization: 0,
      isPercentage: 0,
      noSpecialization: 0,
    },
    profileHeight: 120,
    profileWidth: 120
  };
  readonlySpecialization: boolean;
  country_info: any = {}
  field_text_type: boolean;
  field_text_type1: boolean;
  password_field_text_type: boolean;
  phoneNumber_field_text_type: boolean;
  cv_rating: any;
  cv_rating_title: any;
  comm_rating: any;
  comm_rating_title: any;
  resId = 0;
  lat = 0;
  lang = 0;
  cvAttachments = []
  geo_decoder: google.maps.Geocoder;
  editable: boolean = false;
  openSkillRankingRef: Function;
  @ViewChild('stepper') stepper: MatStepper;
  profileCaptureStarted: boolean;
  random_width = []

  resumeObj: any = {};
  uploadedImageUrl: string | ArrayBuffer;
  isValidCode: boolean = false;
  field_loading: boolean = true;
  referral_code = {
    isVerify: false,
    isValid: false,
    displayName: null,
    referralCode: null,
    message: null
  }
  timeBasedMaster = {
    cityList: [],
    stateList: [],
    locationList: []
  }
  startAt = new Date();
  minValue = new Date()

  copyMobileNumberToWARef: Function
  companySettingsSettings: any;
  addSkillRef: Function;
  valid_education: any;
  educationLevel1 = [];
  educationLevel2 = [];
  educationLevel3 = [];
  current_education: any = {};
  current_education2: any = {};
  current_education3: any = {};
  current_percentage_type: any = {};
  current_percentage_type2: any = {};
  current_percentage_type3: any = {};
  educationForm: UntypedFormGroup = new UntypedFormGroup({
    educationCode: new UntypedFormControl(null),
    specializationCode: new UntypedFormControl(null),
    university: new UntypedFormControl(''),
    universityCode: new UntypedFormControl(null),
    percentage: new UntypedFormControl('', [Validators.min(1), Validators.max(100), Validators.pattern('^[0-9][0-9]$')]),
    mop: new UntypedFormControl('',),
    yop: new UntypedFormControl(''),
    educationTitle: new UntypedFormControl(null),
    specializationTitle: new UntypedFormControl(null),
    educationLevel: new UntypedFormControl(6),
    percentageType: new UntypedFormControl(1),
    passingMN: new UntypedFormControl(null, [Validators.min(new Date().getFullYear() - 80), Validators.max(new Date().getFullYear() + 6)]),
    educationType: new UntypedFormControl(1),
    collegeName: new UntypedFormControl(null),
    collegeId: new UntypedFormControl(null),


  })
  educationForm2: UntypedFormGroup = new UntypedFormGroup({
    educationCode: new UntypedFormControl(null),
    specializationCode: new UntypedFormControl(null),
    university: new UntypedFormControl(''),
    universityCode: new UntypedFormControl(null),
    percentage: new UntypedFormControl('', [Validators.min(1), Validators.max(100), Validators.pattern('^[0-9][0-9]$')]),
    mop: new UntypedFormControl(''),
    yop: new UntypedFormControl(''),
    educationTitle: new UntypedFormControl(null),
    specializationTitle: new UntypedFormControl(null),
    educationLevel: new UntypedFormControl(7),
    percentageType: new UntypedFormControl(1),
    passingMN: new UntypedFormControl(null, [Validators.min(new Date().getFullYear() - 80), Validators.max(new Date().getFullYear() + 6)]),
    educationType: new UntypedFormControl(1),
    collegeName: new UntypedFormControl(null),
    collegeId: new UntypedFormControl(null),

  })
  educationForm3: UntypedFormGroup = new UntypedFormGroup({
    educationCode: new UntypedFormControl(null),
    specializationCode: new UntypedFormControl(null),
    university: new UntypedFormControl(''),
    universityCode: new UntypedFormControl(null),
    percentage: new UntypedFormControl('', [Validators.min(1), Validators.max(100), Validators.pattern('^[0-9][0-9]$')]),
    mop: new UntypedFormControl(''),
    yop: new UntypedFormControl(''),
    educationTitle: new UntypedFormControl(null),
    specializationTitle: new UntypedFormControl(null),
    educationLevel: new UntypedFormControl(8),
    percentageType: new UntypedFormControl(1),
    passingMN: new UntypedFormControl(null, [Validators.min(new Date().getFullYear() - 80), Validators.max(new Date().getFullYear() + 6)]),
    educationType: new UntypedFormControl(1),
    collegeName: new UntypedFormControl(null),
    collegeId: new UntypedFormControl(null),

  })
  educationList = [];
  currentIndex = 0;

  show_map = 1;
  interval;
  process_bar;
  pinterval;
  timer;
  google_search;
  @ViewChild('addresstext', { static: false }) addresstext: any;
  @ViewChild('addresstextPresent', { static: false }) addresstextPresent: any;
  queryParams: any = {};
  selected_tabs = 0;
  careerPortalConfig: any = {};

  constructor(
    private jobs_service: JobService,
    private activated_route: ActivatedRoute,
    private dialog: MatDialog,
    private session_service: SessionService,
    private router: Router,
    private notification_srv: NotificationService,
    private profile_settings: ProfileSettingsService,
    private registration_srv: JobseekerRegistrationService,
    private file_service: FilesService,
    private change_detector: ChangeDetectorRef,
    private translate: TranslateService,
    private session_srv: SessionService,


  ) {
    this.session_service.session.subscribe(res => {
      this.session = res;
    });
    // this.getJobs();
  }

  ngOnInit() {
    console.log(this.activated_route.snapshot.queryParams)
    this.queryParams = this.activated_route.snapshot.queryParams
    let resId
    try {
      resId = parseInt(sessionStorage.getItem('resId'));
    }
    catch (err) {

    }
    this.request.resId = resId;
    this.request.productCode = this.activated_route.snapshot.params.id;
    this.loadMasters();
    this.loadBasics();
    this.profile_settings.getStoredJobList().subscribe(res => {
      console.log(res)
      if (res && res.length) {
        this.job_list = res;
        this.index = this.job_list.findIndex(data => data.productCode == this.activated_route.snapshot.params.id);
      }
      else {
        this.job_list = []
      }
    })




  }

  loadBasics() {
    this.profile_settings.loadDefaultSettings().subscribe(res => {
      if (res && res['data']) {
        this.country_info = res['data'];
        if (res['data'].companySettingsJson) {
          this.companySettingsSettings = jsonDeepParse(res['data'].companySettingsJson);
        }
        if (this.country_info && this.country_info.jobTypeList && this.country_info.jobTypeList.length) {
          this.registrationForm.controls.jobType.patchValue(this.country_info.jobTypeList.filter(data => data.isChecked).map(d => d.jobType))
        }
        this.registrationForm.controls.mobileIsd.patchValue(res['data'].defaultISD)
        if (res && res['data'].fieldConfigFlags) {
          res['data'].fieldConfigFlags = jsonDeepParse(res['data'].fieldConfigFlags);
        }
        prepareFieldConfigFlagsNew(res['data'].fieldConfigFlags, this.educationForm, null, "RES_");
        prepareFieldConfigFlagsNew(res['data'].fieldConfigFlags, this.educationForm2, null, "RES_");
        prepareFieldConfigFlagsNew(res['data'].fieldConfigFlags, this.educationForm3, null, "RES_");
        this.field_config_access = prepareFieldConfigFlagsNew(res['data'].fieldConfigFlags, this.resumeBankForm, this.registrationForm, "RES_");
        console.log(this.field_config_access)
        this.field_loading = false;
      }
    })
    this.startAt.setFullYear(this.startAt.getFullYear() - 15)
    this.minValue.setFullYear(this.minValue.getFullYear() - 60)
    this.copyMobileNumberToWARef = this.copyMobileNumberToWA.bind(this)
    this.openSkillRankingRef = this.openSkillRanking.bind(this)
    this.addSkillRef = this.openSkillBottomSheet.bind(this)
    this.onCandidateRatingChanged(1);
    this.commRating(1);
    if (!this.resId) {
      this.profile_settings.searchMasterWithTimestamp({
        "startPage": 1,
        "limit": 1000,
        "search": "",
        "lastTimeStamp": null
      }, 'get_city_list', 'cityList', 'id').subscribe(res => {
        if (res && res['data'] && res['data'].list) {
          this.timeBasedMaster.cityList = res['data'].list.filter(data => data.type == 1)
          this.timeBasedMaster.locationList = res['data'].list;

        }

      });
    }

    this.stepperOrientation = window.innerWidth < 900 ? 'vertical' : 'horizontal'
  }
  copyMobileNumberToWA() {
    this.registrationForm.controls.waMobileIsd.patchValue(this.registrationForm.value.mobileIsd);
    this.registrationForm.controls.waMobileNumber.patchValue(this.registrationForm.value.mobileNumber);
  }

  openSkillRanking() {
    this.dialog.open(SkillRatingComponent, {
      width: '60%',
      panelClass: 'TM-Dialog',
      data: {
        options: this.resumeBankForm.value.skillRankingList,
        type: 1
      }
    }).afterClosed().subscribe(res => {
      if (res) {
        console.log(res)
        this.resumeBankForm.controls.skillRankingList.patchValue(res);
      }
    })
  }
  openSkillBottomSheet(ev?) {

    // this._bottomSheet.open(AddSkillBottomSheetComponent,{
    //   data:{skillCategoryList: this.skillCategoryList}
    // });
    let matDialogConfig = new MatDialogConfig();
    // matDialogConfig.height = "500px";
    matDialogConfig.width = "40%";
    matDialogConfig.data = {
      skillCategoryList: this.masters.skillCategoryList
    }
    matDialogConfig.panelClass = 'TM-Dialog'

    this.dialog.open(AddResumeSkillsComponent, matDialogConfig).afterClosed().subscribe(data => {

      if (data == 1) {
        // this.selectedFunction({ skillCatCode: 0 }, 1, 0, undefined);

      }
    })
  }

  prevNextJob(index23, type) {
    if (type == 1) { //next
      if (this.index < this.job_list.length - 1) {
        this.index++
        this.request.productCode = this.job_list[this.index].productCode;
        this.getJobs();

      }
      else {
        this.index = 0;
        this.request.productCode = this.job_list[this.index].productCode;
        this.getJobs();
      }
    }
    else { //prev
      if (this.index > 0) {
        this.index--
        this.request.productCode = this.job_list[this.index].productCode;
        this.getJobs();
      }
      else {
        this.index = this.job_list.length - 1;
        this.request.productCode = this.job_list[this.index].productCode;
        this.getJobs();
      }
    }

    try {
      document.getElementById('main-viewport').scrollIntoView({ behavior: 'smooth' })
    }
    catch (err) {
      console.log(err)
    }
  }

  loadMasters() {
    this.profile_settings.loadDefaultSettings().subscribe(res => {
      console.log(res)
      if (res && res['data']) {
        localStorage.setItem('sellerShortCode', res['data'].sellerShortCode);
        this.getJobs();
        this.socialMediaList = res['data'].socialMediaList || []
      }
      if (res && res['data'] && res['data'].companySettingsJson) {
        let portal_details = jsonDeepParse(res['data'].companySettingsJson);
        this.portal_details = portal_details;
        if (portal_details && portal_details.banners && portal_details.banners.length) {
          this.default_banner_url = 'https://storage.googleapis.com/ezeone/icanrefer/' + portal_details.banners[0].cdnPath;
          console.log(this.default_banner_url)
        }
        else {
          this.default_banner_url = 'assets/jobs/wehiring.svg'
        }
      }
      if (res && res['data'] && res['data'].careerPortalConfig) {
        let portal_details = jsonDeepParse(res['data'].careerPortalConfig.portalSettings);
        this.portal_settings = portal_details;
        this.careerPortalConfig = portal_details;
        if (portal_details && portal_details.banners && portal_details.banners.length) {
          this.default_banner_url = 'https://storage.googleapis.com/ezeone/icanrefer/' + portal_details.banners[0].cdnPath;
          console.log(this.default_banner_url)
        }
        else {
          this.default_banner_url = 'assets/jobs/wehiring.svg'
        }
      }
      if (res && res['data'] && res['data'].fieldConfigFlags) {
        this.field_config_access = prepareFieldConfigFlagsNew(res['data'].fieldConfigFlags, null, null, "CAREERS_");
        console.log(this.field_config_access)
      }
    })
  }



  getJob(share_link) {
    this.request.productCode = this.activated_route.snapshot.params.id
    this.jobs_service.getJobs(this.request).subscribe((res) => {
      this.job_details_display = true;

      if (res && res['data']) {
        if (res['data']) {
          if (res['data'].detail) {
            this.jobs = jsonDeepParse(res['data'].detail);
          }
          if (res['data'].relevant_jobs && res['data'].relevant_jobs.length) {
            this.relevant_jobs = res['data'].relevant_jobs || [];
          }
        }
      }
    })
    this.router.navigate(['/job-details/' + share_link]);
  }
  getJobs() {
    console.log(this.request)
    this.jobs_service.getJobs(this.request).subscribe((res) => {
      this.job_details_display = true;

      if (res && res['data']) {
        console.log(res);
        if (res['data']) {
          if (res['data'].detail) {
            this.jobs = jsonDeepParse(res['data'].detail);
            console.log(this.jobs);
            this.jobs.prefJobseekerBranch = jsonParse(this.jobs.prefJobseekerBranch)
          }
          if (res['data'].relevant_jobs && res['data'].relevant_jobs.length) {
            this.relevant_jobs = res['data'].relevant_jobs || [];
          }
          setTimeout(() => {
            try {
              let top = document.getElementById('main-viewport').offsetTop;
              console.log(top)
              window.scrollTo({
                top: top - 10,
                behavior: 'smooth'
              })
            }
            catch (err) {
              console.log(err)
            }
          })
        }
      }
    })
  }
  applyJob(ev) {
    let resId = parseInt(getSessionStorageItem('resId'));
    if (!this.portal_details || this.portal_details && (!this.portal_details.portalDesignPatternSettings || this.portal_details.portalDesignPatternSettings == 1 ||
      this.portal_details.portalDesignPatternSettings == 2)) {
      if (!resId) {
        let route_info = this.router.url;
        let params: any = Object.assign({}, this.activated_route.snapshot.queryParams);
        params['job'] = this.request && this.request.productCode;
        const dialog = this.dialog.open(LoginComponentV2, {
          width: '60%',
          disableClose: true,
          panelClass: "TM-Dialog",
          data: {
            jobDetails: ev,
            params: Object.assign({}, this.activated_route.snapshot.queryParams),
            queryParams: params,
          }
        });
        dialog.afterClosed().subscribe(result => {
          if (result && result.status) {
            this.router.navigate([route_info]);
            this.applyJob(ev);
          }
        });
      }
      if (resId && resId > 0) {
        if (ev && ev.isNewUser) {
          this.router.navigate(['reg'], {
            queryParams: {
              job: ev.productCode
            }
          })
        }
        else {
          if (ev && ev.assessment) {
            try {
              ev.assessment = JSON.parse(ev.assessment)
            }
            catch (err) {

            }
          }
          if (ev && ev.assessment && ev.assessment.length) {
            ev.assessment.forEach(a => {
              a.options = jsonParse(a.options)
            })
            this.dialog.open(ConfirmationComponent, {
              width: '60%',
              height: 'auto',
              panelClass: "TM-Dialog",

              data: {
                title: 'Submit Assessment',
                assessment: ev.assessment,
                positive_button: 'BTN.apply',
                negative_button: 'BTN.cancel'
              }
            }).afterClosed().subscribe(res => {
              if (res) {

                let request = Object.assign({}, this.activated_route.snapshot.queryParams) || {}
                request['assessment'] = res.assessment;
                request['resId'] = resId;
                request['productCode'] = ev.productCode
                this.jobs_service.applyForJob(request).subscribe(res => {
                  if (res && res['status']) {
                    ev.applied = 1;
                    this.notification_srv.success(res['message'], 'Close', 10000);
                  }
                  else {
                    ev.applied = 0;
                    this.notification_srv.error(res['message'], 'Close', 10000);
                  }
                })
              }
            })
          }
          else {
            this.dialog.open(ConfirmationComponent, {
              width: '30%',
              height: 'auto',
              panelClass: "TM-Dialog",

              data: {
                title: 'CONFIRMATION.confirmation',
                message: 'Are you sure to apply for the position',
                message1: ev.productName + ' ',
                positive_button: 'BTN.apply',
                negative_button: 'BTN.cancel'
              }
            }).afterClosed().subscribe(res => {
              if (res) {
                let request = Object.assign({}, this.activated_route.snapshot.queryParams)
                request['assessment'] = [];
                request['resId'] = resId;
                request['productCode'] = ev.productCode
                this.jobs_service.applyForJob(request).subscribe(res => {
                  if (res && res['status']) {
                    ev.applied = 1;
                    this.notification_srv.success(res['message'], 'Close', 10000);
                  }
                  else {
                    ev.applied = 0;
                    this.notification_srv.error(res['message'], 'Close', 10000);
                  }
                })
              }
            })
          }
        }

      }
    }
    else {
      if (this.field_config_access && this.field_config_access['CAREERS_showRegistrationOnDetailsPage']) {
        if (!resId) {
          this.selected_tabs = 1;
          return;
        }
        if (resId && resId > 0) {

          if (ev && ev.isNewUser) {
            this.router.navigate(['reg'], {
              queryParams: {
                job: ev.productCode
              }
            })
          }
          else {
            if (ev && ev.assessment) {
              try {
                ev.assessment = JSON.parse(ev.assessment)
              }
              catch (err) {

              }
            }
            if (ev && ev.assessment && ev.assessment.length) {
              ev.assessment.forEach(a => {
                a.options = jsonParse(a.options)
              })
              this.dialog.open(ConfirmationComponent, {
                width: '60%',
                height: 'auto',
                panelClass: "TM-Dialog",

                data: {
                  title: 'Submit Assessment',
                  assessment: ev.assessment,
                  positive_button: 'BTN.apply',
                  negative_button: 'BTN.cancel'
                }
              }).afterClosed().subscribe(res => {
                if (res) {

                  let request = Object.assign({}, this.activated_route.snapshot.queryParams) || {}
                  request['assessment'] = res.assessment;
                  request['resId'] = resId;
                  request['productCode'] = ev.productCode
                  this.jobs_service.applyForJob(request).subscribe(res => {
                    if (res && res['status']) {
                      ev.applied = 1;
                      this.notification_srv.success(res['message'], 'Close', 10000);
                    }
                    else {
                      ev.applied = 0;
                      this.notification_srv.error(res['message'], 'Close', 10000);
                    }
                  })
                }
              })
            }
            else {
              this.dialog.open(ConfirmationComponent, {
                width: '30%',
                height: 'auto',
                panelClass: "TM-Dialog",

                data: {
                  title: 'CONFIRMATION.confirmation',
                  message: 'Are you sure to apply for the position',
                  message1: ev.productName + ' ',
                  positive_button: 'BTN.apply',
                  negative_button: 'BTN.cancel'
                }
              }).afterClosed().subscribe(res => {
                if (res) {
                  let request = Object.assign({}, this.activated_route.snapshot.queryParams)
                  request['assessment'] = [];
                  request['resId'] = resId;
                  request['productCode'] = ev.productCode
                  this.jobs_service.applyForJob(request).subscribe(res => {
                    if (res && res['status']) {
                      ev.applied = 1;
                      this.notification_srv.success(res['message'], 'Close', 10000);
                    }
                    else {
                      ev.applied = 0;
                      this.notification_srv.error(res['message'], 'Close', 10000);
                    }
                  })
                }
              })
            }
          }

        }
      }
      else {
        if (!resId) {
          let route_info = this.router.url;
          let params: any = Object.assign({}, this.activated_route.snapshot.queryParams);
          params['job'] = this.request && this.request.productCode;
          const dialog = this.dialog.open(LoginComponentV2, {
            width: '50%',
            disableClose: true,
            panelClass: "TM-Dialog",
            data: {
              jobDetails: ev,
              params: Object.assign({}, this.activated_route.snapshot.queryParams),
              queryParams: params,
            }
          });
          dialog.afterClosed().subscribe(result => {
            if (result && result.status) {
              this.router.navigate([route_info]);
              this.applyJob(ev);
            }
          });
        }
        if (resId && resId > 0) {

          if (ev && ev.isNewUser) {
            this.router.navigate(['reg'], {
              queryParams: {
                job: ev.productCode
              }
            })


          }
          else {
            if (ev && ev.assessment) {
              try {
                ev.assessment = JSON.parse(ev.assessment)
              }
              catch (err) {

              }
            }
            if (ev && ev.assessment && ev.assessment.length) {
              ev.assessment.forEach(a => {
                a.options = jsonParse(a.options)
              })
              this.dialog.open(ConfirmationComponent, {
                width: '50%',
                height: 'auto',
                panelClass: "TM-Dialog",

                data: {
                  title: 'Submit Assessment',
                  assessment: ev.assessment,
                  positive_button: 'BTN.apply',
                  negative_button: 'BTN.cancel'
                }
              }).afterClosed().subscribe(res => {
                if (res) {

                  let request = Object.assign({}, this.activated_route.snapshot.queryParams) || {}
                  request['assessment'] = res.assessment;
                  request['resId'] = resId;
                  request['productCode'] = ev.productCode
                  this.jobs_service.applyForJob(request).subscribe(res => {
                    if (res && res['status']) {
                      ev.applied = 1;
                      this.notification_srv.success(res['message'], 'Close', 10000);
                    }
                    else {
                      ev.applied = 0;
                      this.notification_srv.error(res['message'], 'Close', 10000);
                    }
                  })
                }
              })
            }
            else {
              this.dialog.open(ConfirmationComponent, {
                width: '30%',
                height: 'auto',
                panelClass: "TM-Dialog",

                data: {
                  title: 'CONFIRMATION.confirmation',
                  message: 'Are you sure to apply for the position',
                  message1: ev.productName + ' ',
                  positive_button: 'BTN.apply',
                  negative_button: 'BTN.cancel'
                }
              }).afterClosed().subscribe(res => {
                if (res) {
                  let request = Object.assign({}, this.activated_route.snapshot.queryParams)
                  request['assessment'] = [];
                  request['resId'] = resId;
                  request['productCode'] = ev.productCode
                  this.jobs_service.applyForJob(request).subscribe(res => {
                    if (res && res['status']) {
                      ev.applied = 1;
                      this.notification_srv.success(res['message'], 'Close', 10000);
                    }
                    else {
                      ev.applied = 0;
                      this.notification_srv.error(res['message'], 'Close', 10000);
                    }
                  })
                }
              })
            }
          }

        }
      }


    }



  }

  socialMediaShare(productCode) {
    if (productCode) {
      const dialogRef = this.dialog.open(SocialMediaShareComponent, {
        width: '40%',
        data: {
          productCode: productCode || 0,
          share_link: document.URL
        },
        panelClass: "TM-Dialog",
        disableClose: true

      });

      dialogRef.afterClosed().subscribe(result => {

      });
      // window.open("https://www.facebook.com/dialog/share?app_id=2403562973199584&display=page&href=https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2F&redirect_uri=https%3A%2F%2Flocalhost%3A4201%2Fhome", '_blank');
      // window.open("https://twitter.com/intent/tweet?text=Hello%20world");
      // window.open('https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=&su=Your+Subject+here&body="MSG"&ui=2&tf=1&pli=1');
      // window.open("https://www.linkedin.com/shareArticle?mini=true&url=http://23.236.49.140:1123&title=LinkedIn%20Developer%20Network&summary=My%20favorite%20developer%20program&source=LinkedIn");
    }
  }
  referAFriend(requirement_id) {
    const dialog = this.dialog.open(ResumeReferralDetailsComponent, {
      width: '400px',
      disableClose: true,
      panelClass: "TM-Dialog",

    });
    dialog.afterClosed().subscribe(result => {

    },
      (reason) => {
        //
      });
    (dialog.componentInstance).requisition_id = requirement_id;
  }

  resumeApply(requirement_id) {
    const dialog = this.dialog.open(ResumeReferralCopyComponent, {
      width: '400px',
      disableClose: true,
      panelClass: "TM-Dialog",

    });
    dialog.afterClosed().subscribe(result => {

      this.getJobs();
      // if (result) {
      //   this.router.navigate(['/jobs']);
      // }
    },
      (reason) => {
        //
      });
    (dialog.componentInstance).referrer_id = this.activated_route.snapshot.params.user_id;
    (dialog.componentInstance).requirement_id = requirement_id;

  }
  closeSidebar() {
    this.sidebar.close();
  }
  checkPassword(group: UntypedFormGroup) {
    let newPass = group.get('password').value;
    let confirmPass = group.get('confirmPassword').value;
    if (newPass != confirmPass && confirmPass != '') {
      group.get('confirmPassword').setErrors({ notEqual: true });
    }
    if (newPass == confirmPass) {
      group.get('confirmPassword').clearValidators();
    }
    return newPass == confirmPass ? null : { notEqual: true }
  }
  setupDevices(obj) {
    if (!this.profileCaptureStarted) {
      this.notification_srv.success('Please wait while video device is being initializing', 'Close', 5000)
      let out_obj = {
        screenCapture: '',
        error: 'You have no output video device',
        camCapture: '',
        id: 0,
        status: 1
      };
      let width = 400;
      let height = 0;
      let streaming = false;
      let camera = document.getElementById('camera');
      let video: any = document.getElementById('video');
      let startbutton = document.getElementById('startbutton');
      let cancelButton = document.getElementById('cancelButton');
      // camera.appendChild(video)
      // camera.appendChild(cancelButton)
      // camera.appendChild(startbutton)
      video.autoplay = true;

      let canvas = document.createElement('canvas');
      if (obj.isCamShot) {
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          this.profileCaptureStarted = true;
          try {
            navigator.mediaDevices.getUserMedia({ video: true }).then(stream => {
              if (stream) {
                video.srcObject = stream;
                video.play();
                video.addEventListener('canplay', ev => {
                  camera.classList.add('d-flex')
                  if (!streaming) {
                    height = video.videoHeight / (video.videoWidth / width);
                    if (isNaN(height)) {
                      height = width / (4 / 3);
                    }
                    video.setAttribute('width', width.toString());
                    video.setAttribute('height', height.toString());
                    canvas.setAttribute('width', width.toString());
                    canvas.setAttribute('height', height.toString());
                    streaming = true;
                    // var context = canvas.getContext('2d');
                    // canvas.width = width;
                    // canvas.height = height;
                    // context.drawImage(video, 0, 0, width, height);
                    // let img = canvas.toDataURL('image/png');
                    // out_obj.camCapture = img;
                    // stream.getTracks().forEach(function (track) {
                    //   track.stop();
                    // });
                    // video.remove();
                    // canvas.remove();
                    // this.getCDNPath(out_obj)

                  }
                }, false);
                startbutton.addEventListener('click', ev => {
                  var context = canvas.getContext('2d');
                  canvas.width = width;
                  canvas.height = height;
                  context.drawImage(video, 0, 0, width, height);
                  let img = canvas.toDataURL('image/png');
                  out_obj.camCapture = img;

                  stream.getTracks().forEach(function (track) {
                    track.stop();
                  });
                  canvas.remove();
                  camera.classList.remove('d-flex');
                  this.profileCaptureStarted = false;
                  // startbutton.remove();
                  this.getCDNPath(out_obj)
                })
                cancelButton.addEventListener('click', ev => {
                  stream.getTracks().forEach(function (track) {
                    track.stop();
                  });
                  canvas.remove();
                  camera.classList.remove('d-flex');
                  this.profileCaptureStarted = false;
                  // startbutton.remove();
                })
                out_obj.error = null;
              } else {
                out_obj.error = 'You have no output video device';
              }
            }).catch(err => {
              this.profileCaptureStarted = false;
              this.notification_srv.error('RESUME.please_enable_camera_permission_to_capture_photo', 'Close', 8000)
            });
          } catch (e) {
            out_obj.error = e;
          }
        }
      }
    }
    else {

    }


  }

  getCDNPath(obj) {
    let out_obj: any = {
      "id": 0,
      "status": 1,
      "screenCapture": [],
      "camCapture": []
    }

    if (out_obj.camCapture) {
      this.registration_srv.getCDNPath('camCapture.png', obj.camCapture).subscribe(camCapture => {
        let c: any = camCapture;
        if (c && c.length) {
          this.registrationForm.controls.profilePicture.patchValue(c[0].cdnPath);
          this.resumeObj.profilePicture = c[0].cdnPath;
        }
      })
    }
  }
  viewAttachments(item) {
    viewDocument(item.attachments, item.attachments[0], this.dialog, null, 'fileName', 'cdnPath');
  }
  fileInputChanged(event) {

    let reader = new FileReader();
    let file = event.target.files[0];
    // if (file) {
    //   this.result = Object.assign([], file || []);
    //   this.returnFiles.emit({ files: this.result, source: this.flag })
    // }
    // this.profilePhoto = this.dataURItoBlob(file, undefined, undefined);

    this.file_service.convertFilesToBase64(event.target.files).subscribe(res => {
      // this.selected_files = res as any;

      //   this.result = this.selected_files;

    })
    if (event.target.files && event.target.files[0]) {
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.uploadedImageUrl = reader.result;
        // this.registrationForm.patchValue({
        //   file: reader.result
        // });
      }

      this.change_detector.markForCheck();
    }

    // this.result = [];
    // this.parsingInProgress = true;
    // this.hideUploadButton = true;
    // this.imageChangedEvent = files;
  }


  removeUploadedFile() {
    this.dialog
      .open(ConfirmationComponent, {
        width: "480px",
        height: "auto",
        panelClass: "TM-Dialog",
        data: {
          title: "ERROR.confirmation",
          message: "CONFIRMATION.are_you_sure_to_delete",
          positive_button: "BTN.yes",
          negative_button: "BTN.no"
        },
      })
      .afterClosed()
      .subscribe((res) => {
        if (res) {
          this.uploadedImageUrl = ''
          this.resumeObj.profilePicture = '';
          this.registrationForm.controls['profilePicture'].setValue('')
        }
      });

    // this.el.nativeElement.files = []
    // this.el.nativeElement.remove();

    // this.registrationForm.patchValue({
    //   file: [null]
    // });
  }

  fileChanged(ev) {

    if (ev) {
      if (ev && ev.result && ev.result.length) {
        this.cvAttachments = ev.result;
      }
      if (ev.parser_data) {
        if (this.registrationForm.controls.firstName.invalid || !this.registrationForm.value.firstName || this.registrationForm.value.firstName == '') {
          let info = ev.parser_data;
          if (info) {
            try {
              delete (info.cvPath)
              delete (info.cvFileName)
            }
            catch (err) {
              console.log(err)
            }
            this.registrationForm.patchValue(info);
            this.resumeBankForm.controls.totalExp.patchValue(parseInt(info.experience));
            this.resumeBankForm.controls.cvKeywords.patchValue(info.cvKeywords);
            this.resumeBankForm.controls.noticePeriod.patchValue(parseInt(info.noticePeriod));
            this.resumeBankForm.patchValue(info);
            if (this.registrationForm.value.mobileIsd == '' && this.country_info) {
              this.resumeBankForm.controls.mobileIsd.patchValue(this.country_info.defaultISD || '+91')
              this.registrationForm.controls.mobileIsd.patchValue(this.country_info.defaultISD || '+91')
            }
          }
        }
        else {
          this.dialog
            .open(ConfirmationComponent, {
              width: "480px",
              height: "auto",
              panelClass: "TM-Dialog",
              data: {
                title: "ERROR.confirmation",
                message: "RESUME.dataOverrideWarningMessage",
                positive_button: "BTN.yes",
                negative_button: "BTN.no"
              },
            })
            .afterClosed()
            .subscribe((res) => {
              if (res) {
                let info = ev.parser_data;
                if (info) {
                  try {
                    delete (info.cvPath)
                    delete (info.cvFileName)
                  }
                  catch (err) {

                  }

                  this.resumeBankForm.controls.totalExp.patchValue(parseInt(info.experience));
                  this.resumeBankForm.controls.cvKeywords.patchValue(info.cvKeywords);
                  this.resumeBankForm.controls.noticePeriod.patchValue(parseInt(info.noticePeriod));
                  this.registrationForm.patchValue(info);
                }
              }
            });
        }
      }

    }
  }

  register() {
    if (this.registrationForm.valid) {
      if (this.field_config_access && this.field_config_access['RES_captcha']) {
        if (this.valid_captcha_flag) {
          if (this.companySettingsSettings && (this.companySettingsSettings.enableEmailOtpForJS || this.companySettingsSettings.enableSmsOtpForJS)) {
            let req = this.registrationForm.value;
            let form: UntypedFormGroup = new UntypedFormGroup({
              "mobileNumber": new UntypedFormControl(null),
              "mobileIsd": new UntypedFormControl(null),
              "emailId": new UntypedFormControl(null),
              "employeeId": new UntypedFormControl(null),
              "loginId": new UntypedFormControl(null),
              "existingUser": new UntypedFormControl(null),
              "isCVMine": new UntypedFormControl(null),
              "isICR": new UntypedFormControl(0),
              "ip": new UntypedFormControl(null),
            })
            form.patchValue(this.registrationForm.value)
            if (getIP()) {
              form.controls.ip.patchValue(getIP()['ip']);
            }


            this.registration_srv.sendOTP(form.value).subscribe(res => {
              if (res && res['status'] && res['data']) {
                if (res['data'].existingUser || res['data'].userExists) {
                  this.dialog.open(SuccessModalComponent, {
                    width: '40%',
                    panelClass: 'TM-Dialog',
                    data: {
                      success: 0,
                      url: 'login',
                      url_title: "Login",
                      message: res && res['message']

                    }
                  })
                  this.notification_srv.error(res['message'], 'Close', 5000);
                }
                else {
                  this.notification_srv.success(res['message'], 'Close', 5000);
                  this.dialog.open(RegistrationOtpComponent, {
                    width: '40%',
                    panelClass: "TM-Dialog",
                    data: {
                      value: this.registrationForm.value,
                      message: res['message']
                    }
                  }).afterClosed().subscribe(res => {
                    if (res) {
                      this.registrationForm.controls.otp.patchValue(res.otp);
                      let request = this.registrationForm.value;
                      let param = Object.assign({}, this.activated_route.snapshot.queryParams);
                      if (param) {
                        Object.keys(param).forEach(k => {
                          request[k] = param[k]
                        })
                      }
                      this.registration_srv.saveRegistration(request).subscribe(res => {
                        if (res && res['status'] && res['data']) {
                          this.dialog.open(SuccessModalComponent, {
                            width: '40%',
                            panelClass: "TM-Dialog",

                            data: {
                              success: 1,
                              message: res && res['message']
                            }
                          })
                          this.notification_srv.success(res['message'], 'Close', 5000, 1);
                          this.stepper.next();
                          if (res['data'].userDetails) {
                            this.resumeBankForm.controls.resId.patchValue(res['data'].userDetails.resId);
                            this.resId = parseInt(res['data'].userDetails.resId);
                          }
                          if (res['data'].token) {
                            this.stepper_list.forEach(data => {
                              if (data.id == 1) {
                                data.disabled = 1;
                              }
                              else {
                                data.disabled = 0;
                              }
                            })
                            this.session_obj.setUserDetails({
                              firstName: this.registrationForm.value.firstName,
                              lastName: this.registrationForm.value.lastName,
                              token: res['data'].token,
                              secretKey: res['data'].secretKey,
                              resId: this.resumeBankForm.value.resId,
                              emailId: this.resumeBankForm.value.emailId,
                              mobileIsd: this.resumeBankForm.value.mobileIsd,
                              mobileNumber: this.resumeBankForm.value.mobileNumber
                            }
                            )
                            this.session_srv.setUserDetails(this.session_obj.getUserDetails());

                            this.loadResumeWithMasters(this.resumeBankForm.value.resId);
                          }

                        }
                        else {
                          this.dialog.open(SuccessModalComponent, {
                            width: '40%',
                            panelClass: "TM-Dialog",

                            data: {
                              success: 0,
                              url: 'login',
                              url_title: "Login",
                              message: res && res['message']

                            }
                          })
                          this.notification_srv.error(res['message'], 'Close', 5000);
                        }
                      })
                    }
                  })
                }

              }
              else {
                this.notification_srv.success(res['message'], 'Close', 5000);

              }
            })

          }
          else {
            let request = this.registrationForm.value;
            let param = Object.assign({}, this.activated_route.snapshot.queryParams);
            if (param) {
              Object.keys(param).forEach(k => {
                request[k] = param[k]
              })
            }
            this.registration_srv.saveRegistration(request).subscribe(res => {
              if (res && res['status'] && res['data']) {

                if (res['data'].existingUser || res['data'].userExists) {
                  this.dialog.open(SuccessModalComponent, {
                    width: '40%',
                    panelClass: "TM-Dialog",

                    data: {
                      success: 0,
                      url: 'login',
                      url_title: "Login",
                      message: res && res['message']

                    }
                  })
                  this.notification_srv.error(res['message'], 'Close', 5000);
                }
                else {
                  this.notification_srv.success(res['message'], 'Close', 5000, 1);
                  this.stepper.next();
                  if (res['data'].userDetails) {
                    this.resumeBankForm.controls.resId.patchValue(res['data'].userDetails.resId);
                    this.resId = parseInt(res['data'].userDetails.resId);
                    this.editable = true
                  }
                  if (res['data'].token) {
                    this.stepper_list.forEach(data => {
                      if (data.id == 1) {
                        data.disabled = 1;
                      }
                      else {
                        data.disabled = 0;
                      }
                    })
                    this.session_obj.setUserDetails({
                      firstName: this.registrationForm.value.firstName,
                      lastName: this.registrationForm.value.lastName,
                      token: res['data'].token,
                      secretKey: res['data'].secretKey,
                      resId: this.resumeBankForm.value.resId,
                      emailId: this.resumeBankForm.value.emailId,
                      mobileIsd: this.resumeBankForm.value.mobileIsd,
                      mobileNumber: this.resumeBankForm.value.mobileNumber
                    }
                    )
                    this.session_service.setUserDetails(this.session_obj.getUserDetails());

                    this.loadResumeWithMasters(this.resumeBankForm.value.resId);
                  }
                  this.dialog.open(SuccessModalComponent, {
                    width: '40%',
                    panelClass: "TM-Dialog",

                    data: {
                      success: 1,
                      message: res && res['message']
                    }
                  })
                }


              }
              else {
                this.dialog.open(SuccessModalComponent, {
                  width: '40%',
                  panelClass: "TM-Dialog",

                  data: {
                    success: 0,
                    url: 'login',
                    url_title: "Login",
                    message: res && res['message']

                  }
                })
                this.notification_srv.error(res['message'], 'Close', 5000);
              }
            })
          }
        }
        else {
          if (!this.valid_captcha_flag && this.registrationForm.valid) {
            this.notification_srv.error('ERROR.verify_captcha', 'Close', 5000)
          }
        }
      }
      else {
        if (this.companySettingsSettings && (this.companySettingsSettings.enableEmailOtpForJS || this.companySettingsSettings.enableSmsOtpForJS)) {
          let req = this.registrationForm.value;
          let form: UntypedFormGroup = new UntypedFormGroup({
            "mobileNumber": new UntypedFormControl(null),
            "mobileIsd": new UntypedFormControl(null),
            "emailId": new UntypedFormControl(null),
            "employeeId": new UntypedFormControl(null),
            "loginId": new UntypedFormControl(null),
            "existingUser": new UntypedFormControl(null),
            "isCVMine": new UntypedFormControl(null),
            "isICR": new UntypedFormControl(0),
            "ip": new UntypedFormControl(null),
          })
          form.patchValue(this.registrationForm.value)
          if (getIP()) {
            form.controls.ip.patchValue(getIP()['ip']);
          }
          this.registration_srv.sendOTP(form.value).subscribe(res => {
            if (res && res['status'] && res['data']) {
              if (res['data'].existingUser || res['data'].userExists) {
                this.dialog.open(SuccessModalComponent, {
                  width: '40%',
                  panelClass: 'TM-Dialog',
                  data: {
                    success: 0,
                    url: 'login',
                    url_title: "Login",
                    message: res && res['message']

                  }
                })
                this.notification_srv.error(res['message'], 'Close', 5000);
              }
              else {
                this.notification_srv.success(res['message'], 'Close', 5000);
                this.dialog.open(RegistrationOtpComponent, {
                  width: '40%',
                  panelClass: "TM-Dialog",
                  data: {
                    value: this.registrationForm.value,
                    message: res['message']
                  }
                }).afterClosed().subscribe(res => {
                  if (res) {
                    this.registrationForm.controls.otp.patchValue(res.otp);
                    let request = this.registrationForm.value;
                    let param = Object.assign({}, this.activated_route.snapshot.queryParams);
                    if (param) {
                      Object.keys(param).forEach(k => {
                        request[k] = param[k]
                      })
                    }
                    this.registration_srv.saveRegistration(request).subscribe(res => {
                      if (res && res['status'] && res['data']) {
                        this.dialog.open(SuccessModalComponent, {
                          width: '40%',
                          panelClass: "TM-Dialog",

                          data: {
                            success: 1,
                            message: res && res['message']
                          }
                        })
                        this.notification_srv.success(res['message'], 'Close', 5000, 1);
                        this.stepper.next();
                        if (res['data'].userDetails) {
                          this.resumeBankForm.controls.resId.patchValue(res['data'].userDetails.resId);
                          this.resId = parseInt(res['data'].userDetails.resId);
                        }
                        if (res['data'].token) {
                          this.stepper_list.forEach(data => {
                            if (data.id == 1) {
                              data.disabled = 1;
                            }
                            else {
                              data.disabled = 0;
                            }
                          })
                          this.session_obj.setUserDetails({
                            firstName: this.registrationForm.value.firstName,
                            lastName: this.registrationForm.value.lastName,
                            token: res['data'].token,
                            secretKey: res['data'].secretKey,
                            resId: this.resumeBankForm.value.resId,
                            emailId: this.resumeBankForm.value.emailId,
                            mobileIsd: this.resumeBankForm.value.mobileIsd,
                            mobileNumber: this.resumeBankForm.value.mobileNumber
                          }
                          )
                          this.session_service.setUserDetails(this.session_obj.getUserDetails());

                          this.loadResumeWithMasters(this.resumeBankForm.value.resId);
                        }

                      }
                      else {
                        this.dialog.open(SuccessModalComponent, {
                          width: '40%',
                          panelClass: "TM-Dialog",

                          data: {
                            success: 0,
                            url: 'login',
                            url_title: "Login",
                            message: res && res['message']

                          }
                        })
                        this.notification_srv.error(res['message'], 'Close', 5000);
                      }
                    })
                  }
                })
              }

            }
            else {
              this.notification_srv.success(res['message'], 'Close', 5000);

            }
          })

        }
        else {
          let request = this.registrationForm.value;
          let param = Object.assign({}, this.activated_route.snapshot.queryParams);
          if (param) {
            Object.keys(param).forEach(k => {
              request[k] = param[k]
            })
          }
          this.registration_srv.saveRegistration(request).subscribe(res => {
            if (res && res['status'] && res['data']) {

              if (res['data'].existingUser || res['data'].userExists) {
                this.dialog.open(SuccessModalComponent, {
                  width: '40%',
                  panelClass: "TM-Dialog",

                  data: {
                    success: 0,
                    url: 'login',
                    url_title: "Login",
                    message: res && res['message']

                  }
                })
                this.notification_srv.error(res['message'], 'Close', 5000);
              }
              else {
                this.notification_srv.success(res['message'], 'Close', 5000, 1);
                this.stepper.next();
                if (res['data'].userDetails) {
                  this.resumeBankForm.controls.resId.patchValue(res['data'].userDetails.resId);
                  this.resId = parseInt(res['data'].userDetails.resId);
                  this.editable = true
                }
                if (res['data'].token) {
                  this.stepper_list.forEach(data => {
                    if (data.id == 1) {
                      data.disabled = 1;
                    }
                    else {
                      data.disabled = 0;
                    }
                  })
                  this.session_obj.setUserDetails({
                    firstName: this.registrationForm.value.firstName,
                    lastName: this.registrationForm.value.lastName,
                    token: res['data'].token,
                    secretKey: res['data'].secretKey,
                    resId: this.resumeBankForm.value.resId,
                    emailId: this.resumeBankForm.value.emailId,
                    mobileIsd: this.resumeBankForm.value.mobileIsd,
                    mobileNumber: this.resumeBankForm.value.mobileNumber
                  }
                  )
                  this.session_service.setUserDetails(this.session_obj.getUserDetails());

                  this.loadResumeWithMasters(this.resumeBankForm.value.resId);
                }
                this.dialog.open(SuccessModalComponent, {
                  width: '40%',
                  panelClass: "TM-Dialog",

                  data: {
                    success: 1,
                    message: res && res['message']
                  }
                })
              }


            }
            else {
              this.dialog.open(SuccessModalComponent, {
                width: '40%',
                panelClass: "TM-Dialog",

                data: {
                  success: 0,
                  url: 'login',
                  url_title: "Login",
                  message: res && res['message']

                }
              })
              this.notification_srv.error(res['message'], 'Close', 5000);
            }
          })
        }
      }
      // this.registrationForm.controls.latitude.patchValue(this.lat);
      // this.registrationForm.controls.longitude.patchValue(this.lang);



    }
    else {
      this.checkFormValidation = 1;
      getInvalidFields(this.registrationForm, this.translate, this.notification_srv, 'RESUME.')
      markFormGroupTouched(this.registrationForm);

    }


  }

  loadResumeWithMasters(resId) {
    this.registration_srv.getResumeDetailsWithMaster({
      resId: resId,
      sellerShortCode: environment.SHORTCODE
    }).subscribe(res => {
      if (res && res['data']) {
        this.masters = res['data'];
        if (this.masters && this.masters.extendedMasterList) {
          this.masters.extendedMasterList = jsonParse(this.masters.extendedMasterList)
        }
        if (this.masters && this.masters.educationList && this.masters.educationList.length) {
          this.prepareEducationList(this.masters.educationList)
        }
        else {
          this.educationLevel1 = [];
          this.educationLevel2 = [];
          this.educationLevel3 = [];
        }


        if (res['data'].resumeDetails) {
          let data = jsonDeepParse(res['data'].resumeDetails)
          this.registrationForm.patchValue(data)
          this.resumeBankForm.patchValue(data);


          if (data && data.preferredLocation && data.preferredLocation.length) {
            let ids = data.preferredLocation.map(data => data.id);
            this.resumeBankForm.controls.preferredLocationIds.patchValue(ids);
          }
          this.educationList = data.education;
          if (this.educationList && this.educationList.length) {
            for (let i = 0; i < this.educationList.length; i++) {
              let item = this.educationList[i];
              if (i == 0) {
                item.educationLevel = 6
                this.educationForm.patchValue(item);
              }
              else if (i == 1) {
                item.educationLevel = 7;
                this.educationForm2.patchValue(item)
              }
              else if (i == 2) {
                item.educationLevel = 8;
                this.educationForm3.patchValue(item)
              }
            }
            if (this.educationList.length == 1) {
              this.educationForm.controls.educationLevel.patchValue(6)
            }
            else if (this.educationList.length == 2) {
              this.educationForm.controls.educationLevel.patchValue(7)
            }
            else if (this.educationList.length == 3) {
              this.educationForm.controls.educationLevel.patchValue(8)
            }
          }
          this.onCandidateRatingChanged(data.cvRating);
          this.commRating(data.commSkillRating)
          if (data && data.cvPath && data.cvPath != '') {
            this.cvAttachments = [{
              cvPath: data.cvPath,
              cvFileName: data.cvFileName
            }]
          }
          this.registrationForm.controls.address.patchValue(data.presentLocation);

          if (data && data.extendedData) {
            this.resumeBankForm.controls.extendedDataUI.patchValue(data.extendedData)
          }
        }
      }
    })
    this.registration_srv.getKeySkills({
      limit: 1000,
      skillCatCode: 0,
      startPage: 1,
      type: 0,
    }).subscribe(res => {
      if (res && res['data']) {
        this.registration.key_skills = res['data'].list || []
      }
    })
  }
  prepareEducationList(data) {
    if (data && data.length) {
      this.educationLevel1 = data.filter(data => data.educationLevel == 6);
      this.educationLevel2 = data.filter(data => data.educationLevel == 7);
      this.educationLevel3 = data.filter(data => data.educationLevel == 8);
    }
  }

  addLocation() {
    let locations = this.resumeBankForm.value.preferredLocation || [];
    if (locations && locations.length) {
      if (this.current_preferred_location) {
        locations.push(this.current_preferred_location);
        this.resumeBankForm.controls.preferredLocation.patchValue(locations);
        this.google_search = ''
      }
      else {
        this.notification_srv.error('Please select valid location', 'Close', 5000)
      }
    }
    else {
      if (this.current_preferred_location) {
        locations = [this.current_preferred_location];
        this.resumeBankForm.controls.preferredLocation.patchValue(locations);
        this.google_search = ''
      }
      else {
        this.notification_srv.error('Please select valid location', 'Close', 5000)
      }
    }

  }
  parseData(data) {
    data.abilities = jsonParse(data.abilities)
    data.consultants = jsonParse(data.consultants);
    data.education = jsonParse(data.education);
    data.industry = jsonParse(data.industry);
    data.jobType = jsonParse(data.jobType);
    data.keySkills = jsonParse(data.keySkills);
    data.languages = jsonParse(data.languages);
    data.preferredLocation = jsonParse(data.preferredLocation);
    data.roles = jsonParse(data.roles);
    data.workPermits = jsonParse(data.workPermits);
    return data;
  }

  onCandidateRatingChanged(rating) {
    if (rating) {
      try {
        this.cv_rating = rating;
        if (this.masters.cvRatingLevels && this.masters.cvRatingLevels.length) {
          this.cv_rating_title = this.masters.cvRatingLevels[rating - 1].title;
        }
      }
      catch (err) {

      }

    }
  }
  commRating(rating) {

    if (rating) {
      try {
        this.comm_rating = rating;
        if (this.masters.commSkillRatingLevels && this.masters.commSkillRatingLevels.length) {
          this.comm_rating_title = this.masters.commSkillRatingLevels[rating - 1].title;
        }
      }
      catch (err) {

      }

    }
  }

  mobileChange(ev, flag?) {

    if (flag == 1) { //registration seciton
      if (ev) {
        if (ev && ev.mobileNumberLength) {
          this.registration.registration_mobile_length = ev.mobileNumberLength || 15
        }
        else {
          this.registration.registration_mobile_length = 15
        }
      }
    }
    else if (flag == 2) { //personal section mobile number

      if (ev && ev.mobileNumberLength) {
        this.registration.mobile_number_length = ev.mobileNumberLength || 15;
        // if (!this.jobseeker.getting_data) {
        //   // this.resumeBankForm.controls.mobileNumber.reset();
        // }
        this.registrationForm.controls.mobileNumber.setValidators([Validators.minLength(ev.mobileNumberLength || 0), Validators.maxLength(this.registration.mobile_number_length)])
      }
      else {
        this.registration.mobile_number_length = 15
      }
    }
    else if (flag == 3) { //personal section alternative mobile number
      if (ev && ev.mobileNumberLength) {
        this.registration.alt_mobile_number_length = ev.mobileNumberLength || 15
      }
      else {
        this.registration.alt_mobile_number_length = 15
      }
    }



  }

  presentLocationChanged(ev) {
    if (ev) {
      this.resumeBankForm.patchValue({
        latitude: ev.latitude,
        longitude: ev.longitude
      })
    }
  }

  preferredJobTypeChanges(ev) {
    console.log(ev)
    if (ev && ev.length) {
      let maxAge = ev.reduce((acc, curr) => {
        if (curr.minAge > acc) {
          acc = curr.minAge;
        }
        return acc
      }, 0)
      this.startAt = new Date();
      this.startAt.setFullYear(this.startAt.getFullYear() - maxAge)
    }
    else {
      this.startAt = new Date();
      this.startAt.setFullYear(this.startAt.getFullYear() - 15)
    }
  }
  verifyCaptch(ev) {
    this.valid_captcha = ev;
    this.valid_captcha_flag = ev ? true : false;
  }
  deleteLocation(data, index) {
    let loc = this.resumeBankForm.value.preferredLocation || []
    if (loc && loc.length) {
      loc.splice(index, 1)
      loc = [...loc] // render the mat table

    }

  }

  changeEducation(ev, type?) {
    if (!type) {
      this.current_education = ev;
      if (ev) {
        this.educationForm.controls.educationTitle.patchValue(ev.title)
        if (this.field_config_access && this.field_config_access['RES_passingMN']) {
          if (ev.isPassing) {
            this.educationForm.controls.passingMN.setValidators([Validators.required])
            this.educationForm.controls.passingMN.updateValueAndValidity();
          }
          else {
            this.educationForm.controls.passingMN.clearValidators();
            this.educationForm.controls.passingMN.updateValueAndValidity();

          }
        }

        if (this.field_config_access && this.field_config_access['RES_percentage']) {
          if (ev.isPercentage) {
            let validators = []
            validators.push(Validators.required);
            if (this.current_percentage_type && this.current_percentage_type.id) {
              if (this.current_percentage_type.maxVal) {
                validators.push(Validators.max(this.current_percentage_type.maxVal));
              }
              if (this.current_percentage_type.minVal) {
                validators.push(Validators.min(this.current_percentage_type.minVal));
              }
            }
            this.educationForm.controls.percentage.setValidators(validators);
            this.educationForm.controls.percentage.updateValueAndValidity();
          }
          else {
            this.educationForm.controls.percentage.clearValidators();
            let validators = [];
            if (this.current_percentage_type && this.current_percentage_type.id) {
              if (this.current_percentage_type.maxVal) {
                validators.push(Validators.max(this.current_percentage_type.maxVal));
              }
              if (this.current_percentage_type.minVal) {
                validators.push(Validators.min(this.current_percentage_type.minVal));
              }
              this.educationForm.controls.percentage.setValidators(validators);
            }
            this.educationForm.controls.percentage.updateValueAndValidity();

          }
        }


        if (this.field_config_access && this.field_config_access['RES_specializationCode']) {
          if (ev.isSpecialization) {
            this.educationForm.controls.specializationCode.setValidators([Validators.required]);
            this.educationForm.controls.specializationCode.updateValueAndValidity();
          }
          else {
            this.educationForm.controls.specializationCode.clearValidators();
            this.educationForm.controls.specializationCode.updateValueAndValidity();
          }
        }
        if (ev.noSpecialization) {
          this.educationForm.controls.specializationCode.clearValidators();
          this.educationForm.controls.specializationTitle.clearValidators();
          this.educationForm.controls.specializationTitle.patchValue(null)
          this.educationForm.controls.specializationCode.patchValue(null)
          this.educationForm.controls.specializationCode.updateValueAndValidity();
        }

        if (this.field_config_access && this.field_config_access['RES_universityCode']) {
          if (ev.isUniversity) {
            this.educationForm.controls.universityCode.setValidators([Validators.required]);
            this.educationForm.controls.universityCode.updateValueAndValidity();
          }
          else {
            this.educationForm.controls.universityCode.clearValidators();
            this.educationForm.controls.universityCode.updateValueAndValidity();
          }
        }
        if (this.field_config_access && this.field_config_access['RES_collegeId']) {
          if (ev.isCollege) {
            this.educationForm.controls.collegeId.setValidators([Validators.required]);
            this.educationForm.controls.collegeId.updateValueAndValidity();
          }
          else {
            this.educationForm.controls.collegeId.clearValidators();
            this.educationForm.controls.collegeId.updateValueAndValidity();
          }
        }

        this.educationForm.updateValueAndValidity();
      }
    }
    else if (type == 2) {
      this.current_education2 = ev;
      if (ev) {
        this.educationForm2.controls.educationTitle.patchValue(ev.title)
        if (this.field_config_access && this.field_config_access['RES_passingMN']) {
          if (ev.isPassing) {
            this.educationForm2.controls.passingMN.setValidators([Validators.required])
            this.educationForm2.controls.passingMN.updateValueAndValidity();
          }
          else {
            this.educationForm2.controls.passingMN.clearValidators();
            this.educationForm2.controls.passingMN.updateValueAndValidity();
          }
        }

        if (this.field_config_access && this.field_config_access['RES_percentage']) {
          if (ev.isPercentage) {
            let validators = []
            validators.push(Validators.required);
            if (this.current_percentage_type2 && this.current_percentage_type2.id) {
              if (this.current_percentage_type2.maxVal) {
                validators.push(Validators.max(this.current_percentage_type2.maxVal));
              }
              if (this.current_percentage_type2.minVal) {
                validators.push(Validators.min(this.current_percentage_type2.minVal));
              }
            }
            this.educationForm2.controls.percentage.setValidators(validators);
            this.educationForm2.controls.percentage.updateValueAndValidity();
          }
          else {
            this.educationForm2.controls.percentage.clearValidators();
            let validators = [];
            if (this.current_percentage_type2 && this.current_percentage_type2.id) {
              if (this.current_percentage_type2.maxVal) {
                validators.push(Validators.max(this.current_percentage_type2.maxVal));
              }
              if (this.current_percentage_type2.minVal) {
                validators.push(Validators.min(this.current_percentage_type2.minVal));
              }
              this.educationForm2.controls.percentage.setValidators(validators);
            }
            this.educationForm2.controls.percentage.updateValueAndValidity();

          }
        }

        if (this.field_config_access && this.field_config_access['RES_specializationCode']) {
          if (ev.isSpecialization) {
            this.educationForm2.controls.specializationCode.setValidators([Validators.required]);
            this.educationForm2.controls.specializationCode.updateValueAndValidity();
          }
          else {
            this.educationForm2.controls.specializationCode.clearValidators();
            this.educationForm2.controls.specializationCode.updateValueAndValidity();
          }
        }


        if (ev.noSpecialization) {

          this.educationForm2.controls.specializationCode.clearValidators();
          this.educationForm2.controls.specializationTitle.clearValidators();
          this.educationForm2.controls.specializationTitle.patchValue(null)
          this.educationForm2.controls.specializationCode.patchValue(null)
          this.educationForm2.controls.specializationCode.updateValueAndValidity();
        }

        if (this.field_config_access && this.field_config_access['RES_universityCode']) {
          if (ev.isUniversity) {
            this.educationForm2.controls.universityCode.setValidators([Validators.required]);
            this.educationForm2.controls.universityCode.updateValueAndValidity();
          }
          else {
            this.educationForm2.controls.universityCode.clearValidators();
            this.educationForm2.controls.universityCode.updateValueAndValidity();
          }
        }
        if (this.field_config_access && this.field_config_access['RES_collegeId']) {
          if (ev.isCollege) {
            this.educationForm2.controls.collegeId.setValidators([Validators.required]);
            this.educationForm2.controls.collegeId.updateValueAndValidity();
          }
          else {
            this.educationForm2.controls.collegeId.clearValidators();
            this.educationForm2.controls.collegeId.updateValueAndValidity();
          }
        }

        this.educationForm2.updateValueAndValidity();
      }
    }
    else if (type == 3) {
      if (ev) {
        this.educationForm3.controls.educationTitle.patchValue(ev.title)

        if (this.field_config_access && this.field_config_access['RES_passingMN']) {
          if (ev.isPassing) {
            this.educationForm3.controls.passingMN.setValidators([Validators.required])
            this.educationForm3.controls.passingMN.updateValueAndValidity();
          }
          else {
            this.educationForm3.controls.passingMN.clearValidators();
            this.educationForm3.controls.passingMN.updateValueAndValidity();
          }
        }

        if (this.field_config_access && this.field_config_access['RES_percentage']) {
          if (ev.isPercentage) {
            let validators = []
            validators.push(Validators.required);
            if (this.current_percentage_type3 && this.current_percentage_type3.id) {
              if (this.current_percentage_type3.maxVal) {
                validators.push(Validators.max(this.current_percentage_type3.maxVal));
              }
              if (this.current_percentage_type3.minVal) {
                validators.push(Validators.min(this.current_percentage_type3.minVal));
              }
            }
            this.educationForm3.controls.percentage.setValidators(validators);
            this.educationForm3.controls.percentage.updateValueAndValidity();
          }
          else {
            this.educationForm3.controls.percentage.clearValidators();
            let validators = [];
            if (this.current_percentage_type3 && this.current_percentage_type3.id) {
              if (this.current_percentage_type3.maxVal) {
                validators.push(Validators.max(this.current_percentage_type3.maxVal));
              }
              if (this.current_percentage_type3.minVal) {
                validators.push(Validators.min(this.current_percentage_type3.minVal));
              }
              this.educationForm3.controls.percentage.setValidators(validators);
            }
            this.educationForm3.controls.percentage.updateValueAndValidity();

          }
        }

        if (this.field_config_access && this.field_config_access['RES_specializationCode']) {
          if (ev.isSpecialization) {
            this.educationForm3.controls.specializationCode.setValidators([Validators.required]);
            this.educationForm3.controls.specializationCode.updateValueAndValidity();
          }
          else {
            this.educationForm3.controls.specializationCode.clearValidators();
            this.educationForm3.controls.specializationCode.updateValueAndValidity();
          }
        }

        if (ev.noSpecialization) {

          this.educationForm3.controls.specializationCode.clearValidators();
          this.educationForm3.controls.specializationTitle.clearValidators();
          this.educationForm3.controls.specializationTitle.patchValue(null)
          this.educationForm3.controls.specializationCode.patchValue(null)
          this.educationForm3.controls.specializationCode.updateValueAndValidity();
        }

        if (this.field_config_access && this.field_config_access['RES_universityCode']) {
          if (ev.isUniversity) {
            this.educationForm3.controls.universityCode.setValidators([Validators.required]);
            this.educationForm3.controls.universityCode.updateValueAndValidity();
          }
          else {
            this.educationForm3.controls.universityCode.clearValidators();
            this.educationForm3.controls.universityCode.updateValueAndValidity();
          }
        }
        if (this.field_config_access && this.field_config_access['RES_collegeId']) {
          if (ev.isCollege) {
            this.educationForm3.controls.collegeId.setValidators([Validators.required]);
            this.educationForm3.controls.collegeId.updateValueAndValidity();
          }
          else {
            this.educationForm3.controls.collegeId.clearValidators();
            this.educationForm3.controls.collegeId.updateValueAndValidity();
          }
        }

        this.educationForm3.updateValueAndValidity();
      }
    }

  }
  specialicationChanged(ev, type?) {
    if (!type) {
      if (ev) {
        this.educationForm.controls.specializationTitle.patchValue(ev.title)
      }
    }
    else if (type == 2) {
      if (ev) {
        this.educationForm.controls.specializationTitle.patchValue(ev.title)
      }
    }
    else if (type == 3) {
      if (ev) {
        this.educationForm.controls.specializationTitle.patchValue(ev.title)
      }
    }

  }


  percentageTypeChanged(ev, type) {
    if (type == 6) {
      this.current_percentage_type = ev;
      let validators = []
      if (this.current_education && this.current_education.isPercentage) {
        validators.push(Validators.required);
      }
      if (ev && ev.maxVal) {
        validators.push(Validators.max(ev.maxVal))
      }
      if (ev && ev.minVal) {
        validators.push(Validators.min(ev.minVal))
      }
      this.educationForm.controls.percentage.setValidators(validators);
      this.educationForm.controls.percentage.updateValueAndValidity();
    }
    else if (type == 7) {
      this.current_percentage_type2 = ev;
      let validators = []
      if (this.current_education2 && this.current_education2.isPercentage) {
        validators.push(Validators.required);
      }
      if (ev && ev.maxVal) {
        validators.push(Validators.max(ev.maxVal))
      }
      if (ev && ev.minVal) {
        validators.push(Validators.min(ev.minVal))
      }
      this.educationForm2.controls.percentage.setValidators(validators);
      this.educationForm2.controls.percentage.updateValueAndValidity();
    }
    else if (type == 8) {
      this.current_percentage_type3 = ev;
      let validators = []
      if (this.current_education3 && this.current_education3.isPercentage) {
        validators.push(Validators.required);
      }
      if (ev && ev.maxVal) {
        validators.push(Validators.max(ev.maxVal))
      }
      if (ev && ev.minVal) {
        validators.push(Validators.min(ev.minVal))
      }
      this.educationForm3.controls.percentage.setValidators(validators);
      this.educationForm3.controls.percentage.updateValueAndValidity();
    }
  }
  addEducation() {
    if (this.educationForm.valid) {
      let education = this.resumeBankForm.value.education;
      if (typeof education == "string") {
        try {
          education = JSON.parse(education);
          if (education && education.length) {
            let index = education.findIndex(data => data.educationCode == this.educationForm.value.educationCode);
            if (index > -1) {
              education[index] = this.educationForm.value;
            }
            else {
              education.push(this.educationForm.value);
            }
          }
          else {
            education = []
            education.push(this.educationForm.value);
          }
        }
        catch (err) {
          education = []
        }
      } else {
        if (education && education.length) {
          let index = education.findIndex(data => data.educationCode == this.educationForm.value.educationCode);
          if (index > -1) {
            education[index] = this.educationForm.value;
          }
          else {
            education.push(this.educationForm.value);
          }
        }
        else {
          education = []
          education.push(this.educationForm.value);
        }
      }
      this.resumeBankForm.controls.education.patchValue(education);
      this.educationForm.reset();

    }
    else {
      markFormGroupTouched(this.educationForm);
      getInvalidFields(this.educationForm, this.translate, this.notification_srv, 'RESUME.');
    }

  }
  deleteEducation(i) {

    this.dialog.open(ConfirmationComponent, {
      width: '30%',
      height: 'auto',
      panelClass: 'TM-Dialog',
      data: {
        title: 'CONFIRMATION.confirmation',
        message: 'CONFIRMATION.are_you_sure_to_delete',
      }
    }).afterClosed().subscribe(res => {
      if (res) {
        let education = this.resumeBankForm.value.education;
        try {
          if (education && education.length) {
            education.splice(i, 1);
          }
        }
        catch (err) {
          console.log(err)
        }
        this.resumeBankForm.controls.education.patchValue(education)
      }
    })

  }

  saveChanges(panel?) {

    if (this.educationForm.value.educationLevel == 6) {
      let obj = Object.assign({}, this.educationForm.value);
      obj['educationLevel'] = 6
      this.educationList = [obj]
    }
    else if (this.educationForm.value.educationLevel == 7) {
      let obj = Object.assign({}, this.educationForm.value);
      obj['educationLevel'] = 6
      this.educationList = [obj]
      this.educationForm2.controls.educationLevel.patchValue(7)
      this.educationList.push(this.educationForm2.value)
    }
    else if (this.educationForm.value.educationLevel == 8) {
      let obj = Object.assign({}, this.educationForm.value);
      obj['educationLevel'] = 6
      this.educationList = [obj]
      this.educationForm2.controls.educationLevel.patchValue(7)
      this.educationForm3.controls.educationLevel.patchValue(8)
      this.educationList.push(this.educationForm2.value)
      this.educationList.push(this.educationForm3.value)
    }
    this.resumeBankForm.controls.education.patchValue(this.educationList);
  }


  editEducation(index) {
    this.educationForm.reset();
    let education = this.resumeBankForm.value.education;
    try {
      this.educationForm.patchValue(education[index]);
      if (education && education.length) {
        education.splice(index, 1);
      }
    }
    catch (err) {
      console.log(err)
    }
    this.resumeBankForm.controls.education.patchValue(education)
  }
  expiredCallback() {
    this.valid_captcha = "";
    this.valid_captcha_flag = false
    this.change_detector.detectChanges();

  }
  presentMultiLocationChanged(ev) {

    this.resumeBankForm.controls.preferredLocation.patchValue(ev)
  }
  nextStep(cStep?) {
    this.resumeBankForm.patchValue(this.registrationForm.value)
    getInvalidFields(this.resumeBankForm, this.translate, this.notification_srv, 'RESUME.');
    markFormGroupTouched(this.resumeBankForm)
    this.stepper.next()
    console.log(this.currentIndex)
  }
  previousStep(cStep?) {
    this.stepper.previous()
  }

  saveResume() {
    this.saveChanges()
    if (this.registrationForm.valid && this.resumeBankForm.valid) {
      this.resumeBankForm.patchValue(this.registrationForm.value);
      let request = {};
      request = this.resumeBankForm.value;
      request['presentLocation'] = this.registrationForm.value.address;
      if (this.resumeBankForm.value.extendedData && this.resumeBankForm.value.extendedData.length) {
        request['extendedData'] = jsonParse(this.resumeBankForm.value.extendedData);
        if (request['extendedData'] && request['extendedData'].length) {
          for (let i = 0; i < request['extendedData'].length; i++) {
            let item = request['extendedData'][i];
            if (item.mandatory && item.refType != 1 && !item.value) {
              this.notification_srv.error(item.refLabel ? ((item.refLabel || '') + ' is mandatory') : "ERROR.please_fill_mandatory_fields", 'Close', 5000);
              return;
            }
          }
        }
      }

      let params = Object.assign({}, this.activated_route.snapshot.queryParams);
      if (params) {
        try {
          Object.keys(params).forEach(k => {
            request[k] = params[k]
          })
        }
        catch (err) {
          console.log(err)
        }

      }
      if (this.job_list && this.job_list.length && this.index > -1) {
        this.request.productCode = this.job_list[this.index].productCode;
      }
      this.registration_srv.saveResume(request).subscribe(res => {
        if (res && res['status'] && res['data']) {
          if (res && res['data'] && res['data'].resId) {
            this.request.resId = parseInt(res['data'].resId)
          }
          this.notification_srv.success(res['message'], 'Close', 5000);

          if (this.request.productCode) {
            this.dialog.open(ConfirmationComponent, {
              width: '30%',
              height: 'auto',
              panelClass: "TM-Dialog",

              data: {
                title: 'CONFIRMATION.confirmation',
                message: 'Are you sure to apply for the position',
                message1: this.jobs && this.jobs.productName + ' ',
                positive_button: 'BTN.apply',
                negative_button: 'BTN.cancel'
              }
            }).afterClosed().subscribe(res => {
              if (res) {
                this.registration_srv.applyForJob(this.request).subscribe(res => {
                  if (res && res['status']) {
                    this.notification_srv.success(res['message'], 'Close', 5000);
                    if (this.jobs) {
                      this.jobs['applied'] = 1;
                    }
                  }
                  else {
                    this.notification_srv.error(res['message'], 'Close', 5000)
                  }
                })
              }
            })
          }
          else {
            this.router.navigate(['jobs']);
          }
        }
        else {
          if (res) {
            try {
              if (res['message'] == 'Education is mandatory') {
                this.notification_srv.error(res['message'], 'CLose', 5000);
                this.currentIndex = 1;
                return;
              }
            }
            catch (err) {
              this.notification_srv.error(res['message'], 'CLose', 5000)
              return;
            }

            this.notification_srv.error(res['message'], 'CLose', 5000)
          }
          else {
            this.notification_srv.error('Something went wrong please try again after sometime', 'CLose', 5000)
          }
        }
      })
    }
    else {
      getInvalidFieldsV2(this.resumeBankForm, this.translate, this.notification_srv, 'RESUME_', null, this.field_config_access, 'RES_');
      markFormGroupTouched(this.resumeBankForm);
    }


  }

  savebookmark(job, bookmark_flag?) {
    console.log(job)
    let req = {
      productCode: job.productCode,
      markAsFavourite: job.markAsFavourite ? 0 : 1
    }
    console.log(req)
    this.jobs_service.savebookmark(req).subscribe(res => {
      if (res["status"]) {
        job.markAsFavourite = !job.markAsFavourite
        this.notification_srv.success(res['message'], 'Close', 5000)
      }
    })


  }

}

